module.exports = __webpack_public_path__ + "static/oladimeji-f76254b54daaf2ed433e6dc2a445d623.png";